import React from 'react';
import ParentSection from './ParentSection';
import './ParentsOnly.css';


const ParentsOnly = () => {
  return <ParentSection />;
};

export default ParentsOnly;
